import { combineReducers } from 'redux';
import { webMatchPredictionSlice } from '~/pages/EventSaga/WebMatchPrediction/webMatchPredictionSlice';

export const eventSagaReducers = combineReducers({
    webMatchPrediction: webMatchPredictionSlice.reducer,
});
